export default function AboutSection() {
  const stats = [
    { value: "99.9%", label: "Uptime" },
  ];

  return (
    <section id="about" className="w-full py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Section Label */}
        <div className="flex items-center gap-2 mb-4">
          <span className="w-8 h-px bg-gray-400" />
          <span className="text-xs font-semibold tracking-widest uppercase text-gray-400">About Us</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Text */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight mb-6">
              Building the Future<br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-sky-500 to-teal-500">
                of iOS
              </span>
            </h2>
            <p className="text-gray-500 text-lg leading-relaxed mb-6">
              INDOS d.o.o. is a dedicated team of iOS specialists committed to developing modern, high-performance applications. We focus on creating tools that genuinely improve the daily lives of mobile users — from protecting their privacy to optimizing device performance.
            </p>
            <p className="text-gray-500 text-base leading-relaxed mb-10">
              Our approach combines deep technical expertise with a user-first design philosophy. Every product we ship is crafted with precision, tested rigorously, and built to last. We believe that great software should be invisible — it just works, seamlessly and securely.
            </p>

            {/* Values */}
            <div className="flex flex-col gap-4">
              {[
                { icon: "ri-shield-check-line", title: "Security First", desc: "Every product is built with security as the foundation, not an afterthought." },
                { icon: "ri-speed-up-line", title: "Performance Driven", desc: "Optimized code that respects your device's resources and battery life." },
                { icon: "ri-user-heart-line", title: "User Centered", desc: "Intuitive interfaces designed for real people, not just power users." },
              ].map((v) => (
                <div key={v.title} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-sky-50 shrink-0">
                    <i className={`${v.icon} text-sky-500 text-lg`} />
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900 text-sm mb-0.5">{v.title}</p>
                    <p className="text-gray-400 text-sm leading-relaxed">{v.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Visual */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden w-full h-[480px]">
              <img
                src="https://public.readdy.ai/ai/img_res/99479e2d64a1037f7f1d90a5d374fbdb.jpg"
                alt="INDOS d.o.o. team at work"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
            </div>

            {/* Floating Stats Card */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl p-5 flex items-center justify-center w-40">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <p className="text-2xl font-bold text-gray-900">{s.value}</p>
                  <p className="text-xs text-gray-400 mt-0.5">{s.label}</p>
                </div>
              ))}
            </div>

            {/* Accent dot */}
            <div className="absolute -top-4 -right-4 w-24 h-24 rounded-full bg-sky-100 -z-10" />
          </div>
        </div>
      </div>
    </section>
  );
}
